module.exports = __webpack_public_path__ + "img/cert15.336036bb.png";